/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'base-ui/dist/Icon';

// eslint-disable-next-line camelcase
const AuthorSocialProfiles = ({ social_profiles }) => Object.keys(social_profiles).map((type, idx) => {
  if (type === 'twitter' && social_profiles[type]) {
    return (
      <a
        key={`${type}-${idx}`}
        href={`https://twitter.com/${social_profiles[type]}`}
        className="btn transparent-bg twitter-color transparent-border"
        target="_blank"
      >
        <Icon prefix="fab" name="twitter" />
      </a>
    );
  }

  if (type === 'facebook' && social_profiles[type]) {
    return (
      <a
        key={`${type}-${idx}`}
        href={social_profiles[type]}
        className="btn transparent-bg facebook-color transparent-border"
        target="_blank"
      >
        <Icon prefix="fab" name="facebook" />
      </a>
    );
  }

  if (type === 'linkedin' && social_profiles[type]) {
    return (
      <a
        key={`${type}-${idx}`}
        href={social_profiles[type]}
        className="btn transparent-bg linkedin-color transparent-border"
        target="_blank"
      >
        <Icon prefix="fab" name="linkedin" />
      </a>
    );
  }

  if (type === 'instagram' && social_profiles[type]) {
    return (
      <a
        key={`${type}-${idx}`}
        href={social_profiles[type]}
        className="btn transparent-bg instagram-color transparent-border"
        target="_blank"
      >
        <Icon prefix="fab" name="instagram" />
      </a>
    );
  }

  return null;
});

AuthorSocialProfiles.propTypes = {
  social_profiles: PropTypes.object,
};

export default AuthorSocialProfiles;
